import {
  Maybe,
  Money,
  PayOverTimeLoanHistoryDetailsResult,
  PayOverTimeLoanHistoryDetailsResultTypenames,
  SlTitledListComponent,
} from '@varo/graphql-schema-types';
import FetchPayOverTimeHistoryDetails from 'services/graphql/queries/FetchPayOverTimeHistoryDetails';
import { useQuery } from 'urql';

export interface PayOverTimeHistoryDetails {
  loanName?: Maybe<string>;
  fee?: Maybe<Money>;
  originationDate?: Maybe<string | null>;
  principal?: Maybe<Money>;
  totalAmount?: Maybe<Money>;
  transactions?: Maybe<SlTitledListComponent[] | null>;
}

const usePayOverTimeHistoryDetails = (loanId: string) => {
  const [{ data, fetching, error }, refetch] = useQuery<{
    payOverTimeLoanHistoryDetails: PayOverTimeLoanHistoryDetailsResult;
  }>({
    query: FetchPayOverTimeHistoryDetails,
    variables: { loanId },
    requestPolicy: 'network-only',
  });

  const historyDetailsData =
    data?.payOverTimeLoanHistoryDetails?.__typename ===
    PayOverTimeLoanHistoryDetailsResultTypenames.PayOverTimeLoanHistoryDetailsSuccess
      ? data.payOverTimeLoanHistoryDetails
      : null;

  const historyDetailsError =
    data?.payOverTimeLoanHistoryDetails?.__typename ===
    PayOverTimeLoanHistoryDetailsResultTypenames.PayOverTimeLoanHistoryDetailsError
      ? data.payOverTimeLoanHistoryDetails
      : null;

  const combinedError = error || historyDetailsError;

  const resultsObj: PayOverTimeHistoryDetails = {
    loanName: historyDetailsData?.loanName,
    fee: historyDetailsData?.fee as Money,
    originationDate: historyDetailsData?.originationDate,
    principal: historyDetailsData?.principal as Money,
    totalAmount: historyDetailsData?.totalAmount as Money,
    transactions: historyDetailsData?.transactions,
  };

  return {
    error: combinedError,
    resultsObj,
    fetching,
    refetch,
  };
};

export default usePayOverTimeHistoryDetails;
